import { Role } from '@/enums';

import { Badge } from '@/components/common';
import { getRoleLabel, getRoleVariant } from '@/utils';

interface IGroupRole {
  roles: Role[];
}

export const GroupRoles = ({ roles }: IGroupRole) => {
  return (
    <div className="flex flex-row justify-start items-center gap-2">
      {roles.map((role) => (
        <Badge key={role} variant={getRoleVariant(role)} mode="light" border size="sm">
          {getRoleLabel(role)}
        </Badge>
      ))}
    </div>
  );
};
